import { Box, Button, Card, Typography } from '@material-ui/core';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import '../index.css';
import { useDataProvider } from 'ra-core';
import { useNotify, useRefresh, useInput, ImageField } from 'react-admin';
import JoditEditor from 'jodit-react';
import _debounce from 'lodash/debounce';
import TitleText from '../../common/title-text';
import SubtitleText from '../../common/subtitle-text';
import 'jodit';
import 'jodit/build/jodit.min.css';
import HTMLReactParser from 'html-react-parser';

const BlogHtmlEditor = (props) => {
  const editor = useRef(null);
  const {
    input: { name, onChange, value },
    meta: { touched, error },
    isRequired,
  } = useInput(props);

  // const [valueText, setValue] = useState('');

  function handleDebounceFn(e) {
    // onChange(inputValue);
    if (e.currentTarget.innerHTML) {
      onChange(e.currentTarget.innerHTML);
    }
  }

  const debounceFn = useCallback(_debounce(handleDebounceFn, 500), []);

  function handleChange(eOrHtml) {
    const html =
      typeof eOrHtml === 'string'
        ? eOrHtml
        : eOrHtml && eOrHtml.currentTarget && eOrHtml.currentTarget.innerHTML;

    if (html) {
      onChange(html);
    }
  }
  // function handleChange(value) {
  //   // setValue(value);
  //   debounceFn(value);
  // }

  const buttons = [
    'undo',
    'redo',
    '|',
    'bold',
    'strikethrough',
    'underline',
    'italic',
    '|',
    'superscript',
    'subscript',
    '|',
    'align',
    '|',
    'ul',
    'ol',
    'outdent',
    'indent',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'image',
    'video',
    'link',
    'table',
    '|',
    'hr',
    'eraser',
    'copyformat',
    '|',
    'fullsize',
    'selectall',
    'print',
    '|',
    'source',
    '|',
  ];
  const editorConfig = {
    readonly: false,
    autofocus: true,
    saveSelectionOnBlur: true,
    toolbar: true,
    spellcheck: true,
    language: 'en',
    toolbarButtonSize: 'medium',
    toolbarAdaptive: true,
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    //defaultActionOnPaste: "insert_clear_html",
    // buttons: buttons,
    // colors: ['#2e2e2e'],
    colors: {
      greyscale: [
        '#000000',
        '#434343',
        '#666666',
        '#999999',
        '#B7B7B7',
        '#CCCCCC',
        '#D9D9D9',
        '#EFEFEF',
        '#F3F3F3',
        '#FFFFFF',
      ],
      palette: [
        '#980000',
        '#FF0000',
        '#FF9900',
        '#FFFF00',
        '#00F0F0',
        '#00FFFF',
        '#4A86E8',
        '#0000FF',
        '#9900FF',
        '#FF00FF',
      ],
      full: [
        '#E6B8AF',
        '#F4CCCC',
        '#FCE5CD',
        '#FFF2CC',
        '#D9EAD3',
        '#D0E0E3',
        '#C9DAF8',
        '#CFE2F3',
        '#D9D2E9',
        '#EAD1DC',
        '#DD7E6B',
        '#EA9999',
        '#F9CB9C',
        '#FFE599',
        '#B6D7A8',
        '#A2C4C9',
        '#A4C2F4',
        '#9FC5E8',
        '#B4A7D6',
        '#D5A6BD',
        '#CC4125',
        '#E06666',
        '#F6B26B',
        '#FFD966',
        '#93C47D',
        '#76A5AF',
        '#6D9EEB',
        '#6FA8DC',
        '#8E7CC3',
        '#C27BA0',
        '#A61C00',
        '#CC0000',
        '#E69138',
        '#F1C232',
        '#6AA84F',
        '#45818E',
        '#3C78D8',
        '#3D85C6',
        '#674EA7',
        '#A64D79',
        '#85200C',
        '#990000',
        '#B45F06',
        '#BF9000',
        '#38761D',
        '#134F5C',
        '#1155CC',
        '#0B5394',
        '#351C75',
        '#733554',
        '#5B0F00',
        '#660000',
        '#783F04',
        '#7F6000',
        '#274E13',
        '#0C343D',
        '#1C4587',
        '#073763',
        '#20124D',
        '#4C1130',
        '#2e2e2e',
      ],
    },
    buttons: [
      'source',
      '|',
      'bold',
      'strikethrough',
      'underline',
      'italic',
      '|',
      'ul',
      'ol',
      '|',
      'outdent',
      'indent',
      '|',
      'fontsize',
      'brush',
      'paragraph',
      '|',
      'image',
      'video',
      'table',
      'link',
      '|',
      'align',
      'undo',
      'redo',
      '|',
      'hr',
      'eraser',
      'copyformat',
      '|',
      'symbol',
      'fullsize',
      'print',
      'about',
      'preview',
      // {
      //   name: 'insertDate',
      //   tooltip: 'Insert current Date',
      //   exec: (editor) => {
      //     console.log('EdITOR: ', editor.s);
      //     editor.s.insertHTML(new Date().toDateString());
      //   },
      // },
      // {
      //   tooltip: 'Enter text and insert',
      //   icon: 'image',
      //   name: 'insertText',
      //   popup: (editor, current, self, close) => {
      //     console.log('editor: ', editor);
      //     console.log('current: ', current);
      //     console.log('self: ', self);
      //     const form = editor.create.fromHTML(
      //       `<form dir="auto" >
      //         <input id="link-input-id" type="text"/>
      //         <button type="submit" role="button" aria-pressed="false">Insert</button>
      //       </form>`
      //     );
      //     console.log('form: ', form);
      //     let currentSelection = editor.s;
      //     editor.e.on(form, 'submit', (e) => {
      //       e.preventDefault();
      //       // editor.s.insertHTML(new Date().toDateString());
      //       console.log(form.querySelector('#link-input-id').value);
      //       currentSelection.insertHTML(
      //         form.querySelector('#link-input-id').value
      //       );
      //       close();
      //     });

      //     return form;
      //   },
      // },
    ],

    buttonsXS: [
      'bold',
      'image',
      '|',
      'brush',
      'paragraph',
      '|',
      'align',
      '|',
      'undo',
      'redo',
      '|',
      'eraser',
      'dots',
    ],

    // uploader: {
    //   insertImageAsBase64URI: true,
    // },
    colorPickerDefaultTab: 'text',
    removeButtons: [],
    // width: 800,
    // height: 842,
  };

  return (
    <React.Fragment>
      {!props.isShow ? (
        <Box display={'flex'} flexDirection={'column'} height={'600px'}>
          <JoditEditor
            ref={editor}
            value={value}
            onBlur={(newContent) => {
              console.log('save editing: ', newContent);
              handleChange(newContent);
            }} // preferred to use only this option to update the content for performance reasons
            config={editorConfig}
          />
        </Box>
      ) : (
        <Box>
          <Typography gutterBottom className='base-color'>
            PREVIEW
          </Typography>
          <div className='post'>
            <div className='container'>
              <div className='post__head'>
                <div className='post__info'>
                  <TitleText
                    as='h1'
                    color='color-5'
                    variant={undefined}
                    isCentered={undefined}
                  >
                    {props.record?.title || ''}
                  </TitleText>
                  <SubtitleText
                    color='color-5'
                    className='post__description'
                    isCentered={undefined}
                    as={undefined}
                  >
                    {props.record?.shortDescription || ''}
                  </SubtitleText>
                </div>
                <div className='post__img'>
                  <ImageField source='filesPreviewImage' title='title' />
                </div>
              </div>
              <Box> {HTMLReactParser(value)}</Box>
            </div>
          </div>
        </Box>
      )}
    </React.Fragment>
  );
};
export default BlogHtmlEditor;
